export enum SignalingMessageType {
  OFFER = 'offer',
  ANSWER = 'answer',
  ICE_CANDIDATE = 'ice-candidate',
  ERROR = 'error',
  CLOSE = 'close',
}

export enum WebRTCErrorCode {
  UNAUTHORIZED = 'UNAUTHORIZED',
  INVALID_MESSAGE = 'INVALID_MESSAGE',
  HANDLER_ERROR = 'HANDLER_ERROR',
  MEDIA_BRIDGE_FAILURE = 'MEDIA_BRIDGE_FAILURE',
  AGENT_FAILURE = 'AGENT_FAILURE',
}

export const WEBRTC_ERROR_MESSAGES: Record<WebRTCErrorCode, string> = {
  [WebRTCErrorCode.UNAUTHORIZED]: 'Unauthorized: check your connection token',
  [WebRTCErrorCode.INVALID_MESSAGE]: 'Invalid signaling message',
  [WebRTCErrorCode.HANDLER_ERROR]: 'Server handler error',
  [WebRTCErrorCode.MEDIA_BRIDGE_FAILURE]: 'Media bridge failure',
  [WebRTCErrorCode.AGENT_FAILURE]: 'Agent unavailable',
};

export type OfferMessage = {
  type: SignalingMessageType.OFFER;
  sessionId: string;
  data: {
    type: 'offer';
    sdp: string;
  };
  authToken?: string;
  callSid: string;
  caller: string;
  variantId?: string;
  /** For draft calls: set accountId, projectId, and agentVersionOverride instead of authToken */
  accountId?: string;
  projectId?: string;
  agentVersionOverride?: {
    artifactVersion: string;
    lambdaDeploymentVersion: string;
  };
};

export type AnswerMessage = {
  type: SignalingMessageType.ANSWER;
  sessionId: string;
  data: {
    type: 'answer';
    sdp: string;
  };
};

export type IceCandidateMessage = {
  type: SignalingMessageType.ICE_CANDIDATE;
  sessionId: string;
  data: RTCIceCandidateInit;
};

export type ErrorMessage = {
  type: SignalingMessageType.ERROR;
  sessionId: string;
  code: WebRTCErrorCode;
  message: string;
};

export type CloseMessage = {
  type: SignalingMessageType.CLOSE;
  sessionId: string;
};

export type SignalingMessage =
  | OfferMessage
  | AnswerMessage
  | IceCandidateMessage
  | ErrorMessage
  | CloseMessage;
